import ActiveController from "rapid/controller";
import {orderBy} from "lodash";


export class oneBarChartController extends ActiveController {
    constructor($injector, $rootScope, $element, $scope) {
        "ngInject";
        super($injector);

        this.$rootScope = $rootScope;
        this.$scope = $scope;

    }

    $onInit() {
        this.linesArr = this.createLines(Number(this.lines));
        this.minOffset = this.linesArr[0].top;
        this.maxOffset = this.linesArr[this.linesArr.length - 1].top;

        this.dataArr = this.data;
        this.editData();
    }

    createLines(amount) {
        if (typeof amount !== "number" || amount <= 0) {
            amount = 5;
        }
        let lines = [];
        for (let i = 1; i <= amount; i++) {
            lines.push({
               top: (100 / (amount + 1)) * (i + 0.3)
            });
        }
        return lines;
    }

    editData() {
        this.getMaxValue(this.dataArr);
    }

    getMaxValue(data) {
        let el = orderBy(data, "value", "desc")[0].value || 1;
        let dIndex = Math.floor(el/this.linesArr.length) || 1;
        let elRounded = Math.ceil(el/dIndex) * dIndex || 1;
        let step = Math.round(elRounded/(this.linesArr.length - 1)) || 1;
        let stepIndex = el >= 10 ? 5 : 2;
        step = Math.ceil(step/stepIndex) * stepIndex;

        for (let i = 0; i < this.linesArr.length; i++) {
            this.linesArr[this.linesArr.length - i - 1].val = i * step;
        }
    }
}


// WEBPACK FOOTER //
// ./sources/components/charts/one-bar-chart/one-bar-chart.controller.js